var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPptEnviroment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 114,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-898 -510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.25 57C109.25 54.3875 107.112 52.25 104.5 52.25 103.55 52.25 102.719 52.4875 102.006 52.9625L81.7 64.6C81.9375 65.9062 81.9375 67.2125 81.7 68.6375 80.75 73.0312 76.5938 76 72.0813 76L51.0625 76 51.0625 71.25 72.4375 71.25C75.05 71.25 77.1875 69.1125 77.1875 66.5 77.1875 63.8875 75.05 61.75 72.4375 61.75 72.4375 61.75 44.175 61.75 43.9375 61.75 41.9188 61.75 40.0187 62.3438 38.3563 63.2938L4.75 79.5625 21.375 96.1875C29.0938 88.4688 39.0688 85.5 49.875 85.5L72.0813 85.5C73.15 85.5 74.1 85.1437 74.9313 84.55L107.588 60.6812C108.537 59.7313 109.25 58.425 109.25 57Z",
    fill: "#256A77",
    transform: "matrix(1.12281 0 0 1 898 510)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7438 18.05C92.7438 18.05 78.0187 16.15 70.1813 23.9875 64.4812 29.6875 63.8875 38.8312 64.0062 43.5812 61.5125 45.3625 59.375 47.975 57.95 51.0625 57.5938 50.5875 57.3563 50.1125 57 49.6375 57.1187 45.7188 56.525 38.2375 51.8937 33.6063 45.3625 27.075 33.25 28.7375 33.25 28.7375 33.25 28.7375 31.7063 40.85 38.1187 47.3813 42.275 51.5375 48.925 52.3687 52.9625 52.4875 54.15 53.7938 54.9813 55.6938 55.575 57.3563 55.6938 57.7125 55.8125 58.5438 55.8125 59.6125L60.6812 59.6125C60.8 57.1187 61.1562 55.6938 62.1063 53.675 63.2938 50.825 65.3125 48.45 67.6875 47.025 72.5563 47.1437 81.3438 46.3125 86.8063 40.85 94.6437 32.775 92.7438 18.05 92.7438 18.05Z",
    fill: "#256A77",
    transform: "matrix(1.12281 0 0 1 898 510)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptEnviroment);
export default __webpack_public_path__ + "static/media/pptEnviroment.c4a4968f961d2045660db346509b27e4.svg";
export { ForwardRef as ReactComponent };